module.exports = __webpack_public_path__ + "media/images/teaching-hand-99f8e7d9246811171db9bfe7f197d423.png";